<template>
  <div id="auswertung_user">
    <div class="row">
      <div class="col-12">
        <table class="table">
          <thead>
            <tr>
              <th v-for="k in title" :key="k">{{ k }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dat, index) in data" :key="index">
              <td v-for="(d, index) in dat" :key="index+'-'+d">{{ d }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  import config from '../config'

export default {
  props: ['auswertung'],
  watch: {
    auswertung() {
      this.getData();
    }
  },
  data () {
    return {
      title: [],
      data: []
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let token = this.$store.state.token;
      axios.get(config.apiServerAdress + '/'+this.auswertung, {headers: {'x-access-token': token}})
        .then(res => {
          const data = res.data;
          const rank = [];
          const keys = [];

          for (let key in data) {
            const r = data[key];
            rank.push(r);
          }

          for (let k in rank[0]) {
            keys.push(k);
          }

          this.data = rank;
          this.title = keys;
        })
        .catch(error => {
          console.log(error);
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
